import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import { useRef, useState } from 'react';
import { useRootStore } from '../hooks/useRootStore';
import { MdxPlugins } from './MarkdownEditor/MarkdownEditorPlugins';
import { MDXEditor, MDXEditorMethods } from '@mdxeditor/editor';

export interface NewActivityData {
    issueId: number,
    skillId: number,
    comment: string,
    timeStart: Date,
    timeEnd: Date,
    isOffDuty: boolean,
}

export default function ResumePausedIssueDialog({ issueId, onSubmit, onCancel }: { issueId: number, onSubmit: (comments: string) => void, onCancel: () => void }) {

    const [textNotSpecified, setTextNotSpecified] = useState(false);
    const { api } = useRootStore();

    const mdxEditorRef = useRef<MDXEditorMethods>(null);

    const resulmeIssue = async () => {
        const comments = (mdxEditorRef.current?.getMarkdown() ?? '').trim();
        if (comments.trim().length == 0) {
            setTextNotSpecified(true);
            return false;
        } else {
            await api.resumePausedIssue(issueId, comments)
                .then(() => onSubmit(comments));
        }
    }

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth='lg'
            onClose={onCancel}
        >
            <DialogTitle>Возобновление задачи</DialogTitle>
            <DialogContent sx={{ minHeight: '40vh' }}>
                <Box sx={{ mt: 0.5, textAlign: 'left', minHeight: '300px', border: `1px solid ${textNotSpecified ? 'red' : '#cccccc'}`, borderRadius: 1 }} onClick={() => mdxEditorRef.current?.focus()}>
                    <MDXEditor
                        ref={mdxEditorRef}
                        markdown={''}
                        plugins={MdxPlugins.standardPlugins(api, issueId)}
                        onChange={() => setTextNotSpecified(false)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Отмена</Button>
                <Button onClick={resulmeIssue}>Возобновить</Button>
            </DialogActions>
        </Dialog>
    );
}